export const TOPUP_STEP = {
  CONFIRM_ID: 1,
  PACKAGE_METHOD: 2,
  CHECKOUT: 3
}
